export var AINotificationType;
(function (AINotificationType) {
    AINotificationType["ACTIVITY_REMINDER"] = "activity_reminder";
    AINotificationType["STREAK_REMINDER"] = "streak_reminder";
    AINotificationType["MILESTONE_ACHIEVEMENT"] = "milestone_achievement";
    AINotificationType["NEW_RECOMMENDATION"] = "new_recommendation";
    AINotificationType["SKILL_MASTERY"] = "skill_mastery";
    AINotificationType["JOURNEY_ADAPTATION"] = "journey_adaptation";
    AINotificationType["SOCIAL_ACTIVITY"] = "social_activity";
    AINotificationType["CONTENT_SUGGESTION"] = "content_suggestion";
    AINotificationType["RE_ENGAGEMENT"] = "re_engagement";
    AINotificationType["CELEBRATION"] = "celebration";
})(AINotificationType || (AINotificationType = {}));
